import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { addToast } from '~features/toast/ducks';
import { updateOrderFormless } from '~services/api.helpers';
import { completeOrder, newOrder } from '../forms/ducks';

export function useOnEdit() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFormEdit = async ({ fields, setSubmitting, formId, orderId }) => {
    try {
      const orderData = fields;

      const order = await updateOrderFormless(orderId, orderData);
      dispatch(completeOrder(order));
      dispatch(newOrder());
      setSubmitting(false);
      navigate('/tilauslista');

      dispatch(
        addToast({
          message: 'Tilaus päivitetty onnistuneesti',
          type: 'SUCCESS',
        })
      );
    } catch (e) {
      console.error('Error in onFormEdit', e);
      setSubmitting(false);

      dispatch(
        addToast({
          message: 'Tilausta päivittäessä tapahtui virhe',
          type: 'ERROR',
        })
      );
    }
  };

  return onFormEdit;
}
